var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "snackbarContainer",
      staticClass: "mdc-snackbar",
      on: { "MDCSnackbar:closed": _vm.onClosed }
    },
    [
      _c("div", { staticClass: "mdc-snackbar__surface" }, [
        _c(
          "div",
          {
            staticClass: "mdc-snackbar__label",
            attrs: { role: "status", "aria-live": "polite" }
          },
          [_vm._t("default")],
          2
        ),
        _vm._v(" "),
        _vm._m(0)
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mdc-snackbar__actions" }, [
      _c(
        "button",
        {
          staticClass: "mdc-icon-button mdc-snackbar__dismiss material-icons",
          attrs: { title: "Dismiss" }
        },
        [_vm._v("close")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dab1e49", { render: render, staticRenderFns: staticRenderFns })
  }
}